import { eventsTable } from '@/controllers/events-table'
import { customers } from '@/controllers/events'

const [route, action] = ['customers', 'update']

export const updateCustomers = function (data, callback) {
  window[Symbol.for('vue.prototype')].$sendMessageToWorker({ route, action, customers: data })

  eventsTable[customers[action]] = callback
}
